import { render, staticRenderFns } from "./Foods.vue?vue&type=template&id=5109edff&scoped=true"
import script from "./Foods.vue?vue&type=script&lang=js"
export * from "./Foods.vue?vue&type=script&lang=js"
import style0 from "./Foods.vue?vue&type=style&index=0&id=5109edff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5109edff",
  null
  
)

export default component.exports